export function ourNumbersSlider() {
    const $slider = $(".our-numbers-slider");
    $slider.each(function () {
        let $this = $(this);
        $this.slick({
            slidesToScroll: 1,
            slidesToShow: 1,
            rows: 3,
            fade: true,
            arrows: false,
            dots: true,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 1199,
                    settings: {
                        dots: true,
                        arrows: true,
                    }
                },
            ]
        });
        $this.on('beforeChange', function () {
            function digitsCountersInit(digitsCountersItems) {
                const digitsCounters = document.querySelectorAll(".our-numbers-slider [data-digits-counter]");
                if (digitsCounters.length) {
                    digitsCounters.forEach(digitsCounter => {
                        digitsCountersAnimate(digitsCounter);
                    })
                }
            }

            function digitsCountersAnimate(digitsCounter) {
                let startTimestamp = null;
                const duration = parseInt(digitsCounter.dataset.digitsCounter) ? parseInt(digitsCounter.dataset.digitsCounter) : 2000;
                const startValue = digitsCounter.dataset.countText;
                const startValueParsed = parseInt(startValue.replace(/,/g, ''));
                const startPosition = 0;
                const step = (timestamp) => {
                    if (!startTimestamp) startTimestamp = timestamp;
                    const progress = Math.min((timestamp - startTimestamp) / duration, 1);
                    let currentCount = Math.floor(progress * (startPosition + startValueParsed));
                    digitsCounter.innerHTML = currentCount;

                    if (progress < 1) {
                        window.requestAnimationFrame(step);
                    }
                };
                window.requestAnimationFrame(step);
            }

            digitsCountersInit();
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/ourNumbersSlider.js